import { CommonModule } from "@angular/common";
import { Component, inject, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { OrderTicket } from "@models/order";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../../shared/components/dialog-header/dialog-header.component";

export interface TicketDetailsDialogData {
  ticket: OrderTicket;
}

@Component({
  selector: "app-ticket-details-dialog",
  imports: [CommonModule, ButtonComponent, MatDialogModule, DialogHeaderComponent],
  templateUrl: "./ticket-details-dialog.component.html",
  styleUrl: "./ticket-details-dialog.component.scss",
})
export class TicketDetailsDialogComponent {
  readonly dialogRef = inject(MatDialogRef<TicketDetailsDialogComponent>);

  ticket: OrderTicket;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TicketDetailsDialogData) {
    this.ticket = data.ticket;
  }

  maskCpf(cpf: string) {
    return cpf.slice(0, 3) + "********" + cpf.slice(8);
  }
}
